import { render } from "./NotFound.vue?vue&type=template&id=a99cdb76&scoped=true"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=a99cdb76&lang=scss&scoped=true"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a99cdb76"]])

export default __exports__